'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _PropTypes = require('../utils/PropTypes');

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _jssThemeReactor = require('jss-theme-reactor');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _ButtonBase = require('../internal/ButtonBase');

var _ButtonBase2 = _interopRequireDefault(_ButtonBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('IconButton', function (theme) {
  var palette = theme.palette,
      transitions = theme.transitions,
      typography = theme.typography;


  return {
    iconButton: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      flex: '0 0 auto',
      fontSize: typography.rhythmByUnit(3),
      width: theme.variables.inputHeight,
      height: theme.variables.inputHeight,
      padding: 0,
      borderRadius: '50%',
      backgroundColor: 'transparent',
      color: palette.action.active,
      zIndex: theme.zIndex.baseIndex,
      transition: transitions.create('background-color', {
        duration: transitions.duration.short
      })
    },
    disabled: {
      color: palette.action.disabled
    },
    accent: typography.highlight,
    error: typography.error,
    secondary: typography.secondary,
    primary: typography.primary,
    colorInherit: {
      color: 'inherit'
    },
    heightInherit: {
      height: 'inherit'
    },
    sizeInherit: {
      fontSize: '1em'
    },
    contrast: {
      color: palette.getContrastText(palette.primary[500])
    },
    label: {
      width: '100%',
      display: 'flex',
      alignItems: 'inherit',
      justifyContent: 'inherit',
      '& .material-icons': {
        width: '1em',
        height: '1em'
      }
    },
    keyboardFocused: {
      backgroundColor: palette.text.divider
    }
  };
});

/**
 * @see https://material.google.com/components/buttons.html
 *
 * ```js
 * import IconButton from 'pushbot-ui/IconButton';
 *
 * const Component = () => <IconButton>delete</IconButton>;
 * ```
 */
var IconButton = (_temp = _class = function (_PureComponent) {
  _inherits(IconButton, _PureComponent);

  function IconButton() {
    _classCallCheck(this, IconButton);

    return _possibleConstructorReturn(this, (IconButton.__proto__ || Object.getPrototypeOf(IconButton)).apply(this, arguments));
  }

  _createClass(IconButton, [{
    key: 'render',
    value: function () {
      function render() {
        var _classNames;

        var _props = this.props,
            accent = _props.accent,
            buttonRef = _props.buttonRef,
            children = _props.children,
            className = _props.className,
            colorInherit = _props.colorInherit,
            contrast = _props.contrast,
            disabled = _props.disabled,
            error = _props.error,
            heightInherit = _props.heightInherit,
            primary = _props.primary,
            ripple = _props.ripple,
            secondary = _props.secondary,
            sizeInherit = _props.sizeInherit,
            other = _objectWithoutProperties(_props, ['accent', 'buttonRef', 'children', 'className', 'colorInherit', 'contrast', 'disabled', 'error', 'heightInherit', 'primary', 'ripple', 'secondary', 'sizeInherit']);

        var classes = this.context.styleManager.render(styleSheet);

        return _react2['default'].createElement(
          _ButtonBase2['default'],
          _extends({
            className: (0, _classnames2['default'])(classes.iconButton, (_classNames = {}, _defineProperty(_classNames, classes.colorInherit, colorInherit && !(primary || contrast || secondary || accent || error || disabled)), _defineProperty(_classNames, classes.primary, primary && !(contrast || secondary || accent || error || disabled)), _defineProperty(_classNames, classes.contrast, contrast && !(secondary || accent || error || disabled)), _defineProperty(_classNames, classes.secondary, secondary && !(accent || error || disabled)), _defineProperty(_classNames, classes.accent, accent && !(error || disabled)), _defineProperty(_classNames, classes.error, error && !disabled), _defineProperty(_classNames, classes.disabled, disabled), _defineProperty(_classNames, classes.sizeInherit, sizeInherit), _defineProperty(_classNames, classes.heightInherit, heightInherit), _classNames), className),
            centerRipple: ripple,
            keyboardFocusedClassName: classes.keyboardFocused,
            ref: buttonRef
          }, Object.assign({ disabled: disabled, ripple: ripple }, other)),
          _react2['default'].createElement(
            'span',
            { className: (0, _classnames2['default'])(classes.label) },
            children
          )
        );
      }

      return render;
    }()
  }]);

  return IconButton;
}(_react.PureComponent), _class.propTypes = {
  /**
   * If true, will use the theme's accent color.
   */
  accent: _PropTypes2['default'].bool,
  /**
   * @ignore
   */
  buttonRef: _PropTypes2['default'].func,
  /**
   * The icon element. If a string is passed,
   * it will be used as a material icon font ligature.
   */
  children: _PropTypes2['default'].node,
  /**
   * The CSS class name of the root element.
   */
  className: _PropTypes2['default'].string,
  /**
   * If `true`, the text will use the parent element's color.
   */
  colorInherit: _PropTypes2['default'].bool,
  /**
   * If true, will use the theme's contrast color.
   */
  contrast: _PropTypes2['default'].bool,
  /**
   * If `true`, the button will be disabled.
   */
  disabled: _PropTypes2['default'].bool,
  /**
   * If `true`, the text will use the theme's error color.
   */
  error: _PropTypes2['default'].bool,
  /**
   * If `true`, the text will use the theme's primary color.
   */
  primary: _PropTypes2['default'].bool,
  /**
   * If false, the ripple effect will be disabled.
   */
  ripple: _PropTypes2['default'].bool,
  /**
   * If `true`, the text will use the theme's secondary color.
   */
  secondary: _PropTypes2['default'].bool,
  /**
   * If `true`, the text will use the parent element's font size.
   */
  sizeInherit: _PropTypes2['default'].bool,
  /**
   * If `true`, the text will use the parent element's height.
   */
  heightInherit: _PropTypes2['default'].bool
}, _class.defaultProps = {
  accent: false,
  error: false,
  colorInherit: true,
  contrast: false,
  disabled: false,
  heightInherit: false,
  primary: false,
  ripple: false,
  secondary: false,
  sizeInherit: false
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _temp);
exports['default'] = IconButton;


IconButton.displayName = 'IconButton';


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/IconButton/IconButton.js
// module id = 1646
// module chunks = 32